import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function AnnouncementBar() {
  const [timeLeft, setTimeLeft] = useState({
    days: 2,
    hours: 0,
    minutes: 14,
    seconds: 8
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          days,
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else {
          seconds = 59;
          if (minutes > 0) {
            minutes--;
          } else {
            minutes = 59;
            if (hours > 0) {
              hours--;
            } else {
              hours = 23;
              if (days > 0) {
                days--;
              }
            }
          }
        }
        return {
          days,
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="bg-blue-600 text-white text-sm py-2 px-4 flex justify-center items-center gap-2 font-medium" data-id="element-10">
      <span data-id="element-11">¡OFERTA ESPECIAL DE LANZAMIENTO!</span>
      <Clock className="w-4 h-4 ml-2" data-id="element-12" />
      <span data-id="element-13">
        {timeLeft.days}d {timeLeft.hours.toString().padStart(2, '0')}h{' '}
        {timeLeft.minutes.toString().padStart(2, '0')}m{' '}
        {timeLeft.seconds.toString().padStart(2, '0')}s Left
      </span>
    </div>;
}